export const projectDetails = [
   {
      id:"01",
      name:"Office Management",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg"
      ],
      budget:"35455",
      client:"Keith Terry",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"Active",
      statusColor:"success"


   },
   {
      id:"02",
      name:"Project Management",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg"
      ],
      budget:"15455",
      client:"Chris Garrison",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"inActive",
      statusColor:"danger"

   },
   {
      id:"03",
      name:"Hotel Management",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg",						
      ],
      budget:"45455",
      client:"Anna Valero",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"Active",
      statusColor:"success"

   },
   {
      id:"04",
      name:"Video Calling App",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg",						
      ],
      budget:"3545",
      client:"Destiny Parker",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"inActive",
      statusColor:"danger"

   },
   {
      id:"05",
      name:"Hospital Administration",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg",						
      ],
      budget:"85455",
      client:"Carol Richards",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"Active",
      statusColor:"success"

   },
   {
      id:"06",
      name:"Hotel Management",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg",						
      ],
      budget:"85455",
      client:"Nicole Johnston",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"inActive",
      statusColor:"danger"

   },
   {
      id:"07",
      name:"Office Management",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg",						
      ],
      budget:"85455",
      client:"Pearl Pinheiro",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"Active",
      statusColor:"success"

   },
   {
      id:"08",
      name:"Hospital Management",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg",						
      ],
      budget:"55455",
      client:"Janet Moore",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"inActive",
      statusColor:"danger"

   },
   {
      id:"09",
      name:"Hotel Management",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg",						
      ],
      budget:"45455",
      client:"Anna Valero",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"Active",
      statusColor:"success"

   },
   {
      id:"10",
      name:"Video Calling App",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg",						
      ],
      budget:"3545",
      client:"Destiny Parker",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"inActive",
      statusColor:"danger"

   },
   {
      id:"11",
      name:"Hospital Administration",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg",						
      ],
      budget:"85455",
      client:"Carol Richards",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"Active",
      statusColor:"success"

   },
   {
      id:"12",
      name:"Hotel Management",
      description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ad recusandae quasi perferendis delectus, sequi enim repellendus harum praesentium culpa assumenda non!",
      deadline:"15/feb/2019",
      progressValue:60,
      teamImage:[
         "/static/img/user-1.jpg",
         "/static/img/user-2.jpg",
         "/static/img/user-3.jpg",
         "/static/img/user-4.jpg",
         "/static/img/user-5.jpg",						
      ],
      budget:"85455",
      client:"Nicole Johnston",
      department:"Sale",
      duration:"01/jan/2019",
      projectManager:"Ron Potter",
      status:"Active",
      statusColor:"success"

   },
]
 